import './DateTime.css';
import { customElement } from 'solid-element';
import { DateTime } from './lib/DateTime';

// Register the custom element
customElement('solid-date-time', {
    document: undefined as any,
    template: undefined as any,
    componentDefinition: undefined as any,
    fieldValue: undefined,
    fieldName: '',
    previousFieldValue: '',
    key: 0,
    formParameters: undefined as any,
}, DateTime);

// Export the component for testing
export { DateTime };
